import IC_NONE from "@/assets/record/ic_none.png";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import { useMemo } from "react";
import SummarySkeleton from "../SummarySkeleton";
import MeetingContent from "./sections/MeetingContent";
import MeetingSummary from "./sections/MeetingSummary";
import Todo from "./sections/Todo";
import PanelTitleTip from "./PanelTitleTip";

export default function SummaryPanel() {
  const summary = summaryStore((state) => state.summary);
  const summaryStreamLoading = summaryStore(
    (state) => state.summaryStreamLoading
  );
  const summaryLoading = summaryStore((state) => state.summaryLoading);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const detailInfo = summarySrcStore((state) => state.detailInfo);


  const loading = shareInfo
    ? !summary?.summaryFinish || retryStatus === 1
    : summaryLoading || !detailInfo;

  const isEmpty = useMemo(() => {
    let totalContent: string[] = [];
    if (summary?.srcAiGcContent?.meetingSummary) {
      totalContent = totalContent.concat(
        summary?.srcAiGcContent?.meetingSummary
      );
    }
    if (summary?.srcAiGcContent?.content) {
      totalContent = totalContent.concat(summary?.srcAiGcContent?.content);
    }
    if (summary?.srcAiGcContent?.todo) {
      totalContent = totalContent.concat(summary?.srcAiGcContent?.todo);
    }

    if (!summary) {
      return false;
    }

    return (
      !totalContent.length ||
      (!summary?.srcAiGcContent?.meetingSummary &&
        !summary?.srcAiGcContent?.content &&
        !summary?.srcAiGcContent?.todo)
    );
  }, [summary]);

  const { meetingSummaryLoading, contentLoading, todoLoading } =
    summaryStreamLoading;

  return (
    <div>
      <div>
        {isEmpty && !loading && retryStatus !== 1 && !meetingSummaryLoading && !contentLoading && !todoLoading ? (
          <>
            <div className="flex flex-col flex-justify-center flex-items-center mt-36">
              <img src={IC_NONE} className="w-20 h-20" />
              <span className="mt-1 text-mx-quaternary text-3.5">暂无总结</span>
            </div>
          </>
        ) : (
          <>
            <PanelTitleTip title="会议概要" />
            {meetingSummaryLoading || loading ? (
              <SummarySkeleton className="mt-2 max-w-200" />
            ) : (
              <MeetingSummary />
            )}
            <PanelTitleTip title="会议内容" className="mt-8" />
            {contentLoading || loading ? (
              <div className="flex flex-col">
                <SummarySkeleton className="mt-2 max-w-200 " />
                <SummarySkeleton className="mt-2 max-w-200" />
              </div>
            ) : (
              <MeetingContent />
            )}
            <PanelTitleTip title="会议待办" className="mt-8" />
            {todoLoading || loading ? (
              <SummarySkeleton className="mt-2 max-w-200" />
            ) : (
              <Todo />
            )}
          </>
        )}
      </div>
    </div>
  );
}
